<ng-container *ngIf="customerAccount">
    <header class="header--well">
        <ul>
            <li class="header__title">
                <h2>Edit Account &ndash; {{customerAccount.accountName}} ({{customerAccount.customerAccountNumberId}})</h2>
            </li>
            <li>
                <div class="pull-right"><b>Account Balance:</b> {{customerAccount.accountBalance.toFixed(2) | dollar}}</div>
            </li>
        </ul>
    </header>

    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="well">
        <h2>Account Details</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Account Type</label>
                    <div class="mvd_form-control">{{customerAccount.accountType}}</div>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Account Status</label>
                    <select class="mvd_form-control" [(ngModel)]="statusId">
                        <option *ngFor="let status of customerAccountStatus" value="{{status.id}}">{{status.displayValue}}</option>
                    </select>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Account Name</label>
                    <input class="mvd_form-control" type="text" [(ngModel)]="customerAccount.accountName"/>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Description</label>
                    <input class="mvd_form-control" type="text" [(ngModel)]="customerAccount.accountDescription"/>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Type</label>
                    <div class="mvd_form-control">Mailing</div>
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Address</label>
                    <input class="mvd_form-control" type="text" [value]="customerAccount.accountAddress?.addressLine1" disabled/>
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Ste, Apt, Etc</label>
                    <input class="mvd_form-control" type="text" [value]="customerAccount.accountAddress?.addressLine2" disabled/>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label>ZIP Code</label>
                    <p-inputMask [ngModel]="customerAccount.accountAddress?.postalZipCode" mask="99999?-9999" disabled></p-inputMask>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>City</label>
                    <input class="mvd_form-control" type="text" [value]="customerAccount.accountAddress?.city" disabled/>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>State</label>
                    <input class="mvd_form-control" [value]="getValues(customerAccount.accountAddress?.jurisdictionId, states)" disabled>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>County</label>
                    <input class="mvd_form-control" [value]="getValues(customerAccount.accountAddress?.countyId, counties)" disabled>
                </div>
                <!--<div class="col-sm-3 mvd_form-group">Country</div>-->
            </div>
        </fieldset>

        <h2>Contact Methods</h2>
        <table class="mvd_table--primeng">
            <thead>
                <tr>
                    <th>Contact Type</th>
                    <th>Contact Info</th>
                    <th>Text/Email Enabled</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Personal Email Address</td>
                    <td><input class="mvd_form-control" type="text" [(ngModel)]="personalEmail.customerContactValue" /></td>
                    <td><input type="checkbox" [(ngModel)]="personalEmail.isCorrespondenceEnabled" /></td>
                </tr>
                <tr>
                    <td>Personal Cell Phone</td>
                    <td><input class="mvd_form-control" type="text" [(ngModel)]="personalCellPhone.customerContactValue" /></td>
                    <td><input type="checkbox" [(ngModel)]="personalCellPhone.isCorrespondenceEnabled" /></td>
                </tr>
                <tr *ngFor="let contact of otherContacts">
                    <td>{{getValues(contact.contactMethodTypeID, contactMethodEnum)}}</td>
                    <td><input class="mvd_form-control" type="text" [(ngModel)]="contact.customerContactValue" /></td>
                    <td><input type="checkbox" [(ngModel)]="contact.isCorrespondenceEnabled" *ngIf="correspondenceContactTypes.indexOf(contact.contactMethodTypeID) != -1" /></td>
                </tr>
            </tbody>
        </table>

        <div class="well__footer">
            <div class="btn--group">
                <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
                <mvm-spinner-btn [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="save()"></mvm-spinner-btn>
            </div>
        </div>
    </div>
</ng-container>